import { defineStore } from "pinia"

export const useAuthStore = defineStore("auth", {
    state: () => {
        return {
            avatar: null,
            lastname: null,
            firstname: null,
            email: null,
            role: null,
            organisation: null,
            groups: []
        }
    },

    getters: {},

    actions: {},

    persist: {
        storage: localStorage
    }
})